// src/hooks/useInscripcionForm.js
import { useState, useMemo } from 'react';
import { Form } from 'antd';

export const useInscripcionForm = (esGratis) => {
  const [currentStep, setCurrentStep] = useState(0);
  const [selectedHorarios, setSelectedHorarios] = useState([]);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [tipoInscripcion, setTipoInscripcion] = useState('para_mi');
  const [selectedFamiliar, setSelectedFamiliar] = useState(null);
  const [form] = Form.useForm();

  const stepsConfig = useMemo(() => {
    if (esGratis) {
      return [
        { title: "Horarios", key: "horarios" },
        { title: "Datos", key: "datos" },
        { title: "Confirmar", key: "confirmar" }
      ];
    }
    return [
      { title: "Horarios", key: "horarios" },
      { title: "Plan", key: "plan" },
      { title: "Datos", key: "datos" },
      { title: "Confirmar", key: "confirmar" }
    ];
  }, [esGratis]);

  const getCurrentStepKey = () => stepsConfig[currentStep]?.key;

  const toggleHorario = (horario) => {
    setSelectedHorarios(prev => {
      const existe = prev.find(h => h._id === horario._id);
      if (existe) {
        return prev.filter(h => h._id !== horario._id);
      } else {
        return [...prev, horario];
      }
    });
  };

  const nextStep = () => {
    document.getElementById('formulario-inscripcion')?.scrollIntoView({ 
      behavior: 'smooth', 
      block: 'start' 
    });
    setCurrentStep(prev => prev + 1);
  };

  const prevStep = () => {
    document.getElementById('formulario-inscripcion')?.scrollIntoView({ 
      behavior: 'smooth', 
      block: 'start' 
    });
    setCurrentStep(prev => prev - 1);
  };

  return {
    form,
    currentStep,
    stepsConfig,
    getCurrentStepKey,
    selectedHorarios,
    setSelectedHorarios,
    toggleHorario,
    selectedPlan,
    setSelectedPlan,
    tipoInscripcion,
    setTipoInscripcion,
    selectedFamiliar,
    setSelectedFamiliar,
    nextStep,
    prevStep
  };
};
